import { HIDDEN_TABLE_CLASS_NAME, MATCH_TYPE } from "./const";

const findAncestor = (node_, className) => {
  let node = node_;
  do {
    if (node?.parentNode?.classList?.contains(className)) {
      return node;
    }
  } while ((node = node.parentNode));

  return node;
};

const classesToIgnore = {
  modalDialog: "modalDialog",
  toc: "content-page-toc",
  DMX_a: "DMX_a",
};

const findTableAncestor = (node) => findAncestor(node, HIDDEN_TABLE_CLASS_NAME);
const isInTOC = (node) => findAncestor(node, classesToIgnore.toc) !== null;
const isInsideSectionTitle = (node) =>
  node.parentNode?.tagName?.toLowerCase() === "h2";

// Following two functions are mainly for Drug Details

// Exclude content in a modal
const isInsideModal = (node) =>
  findAncestor(node, classesToIgnore.modalDialog) !== null;

// Exclude content in anchor tag without href
const isHiddenLink = (node) => {
  const anchorElement = findAncestor(node, classesToIgnore.DMX_a);
  return (
    anchorElement !== null &&
    anchorElement.parentNode !== null &&
    anchorElement.parentNode.getAttribute("href") === null
  );
};

const isNodeHidden = (node, canSearchInTables) =>
  (!canSearchInTables && !!findTableAncestor(node)) ||
  isInsideModal(node) ||
  isHiddenLink(node);

const isNodeSearchable = (node, canSearchInTables) =>
  !isNodeHidden(node, canSearchInTables) &&
  !isInsideSectionTitle(node) &&
  !isInTOC(node);

export const createTreeWalker = (body, regExp, canSearchInTables) =>
  document.createTreeWalker(
    body,
    NodeFilter.SHOW_TEXT,
    function (node) {
      // Check if it matches the term, and if it does, that it is included in search
      return node.nodeValue.match(regExp) &&
        isNodeSearchable(node, canSearchInTables)
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    },
    false
  );

export const getMatchingDOMNodes = (bodyDOM, regExp, canSearchInTables) => {
  const walker = createTreeWalker(bodyDOM, regExp, canSearchInTables);

  const nodes = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (canWalkOverNode(node)) {
      nodes.push(node);
    }
  }
  return nodes;
};

export const canWalkOverNode = (node) => node.parentNode.className !== "data";

export const getMatchContext = (node) => {
  const tableAncestor = findTableAncestor(node);
  const type = tableAncestor ? MATCH_TYPE.TABLE : MATCH_TYPE.SECTION;

  const meta = type === MATCH_TYPE.TABLE ? { tableId: tableAncestor.id } : {};

  return { type, meta };
};

export const areContextsEqual = (left, right) => {
  if ((!left && right) || (!right && left)) {
    return false;
  }
  if (left.type !== right.type) {
    return false;
  }
  if (left.meta.tableId !== right.meta.tableId) {
    return false;
  }
  return true;
};

export const makeMatchesStats = (currentMatchIndex, matchesCount) =>
  `${matchesCount > 0 ? currentMatchIndex + 1 : 0} / ${matchesCount}`;

export const waitForNextFrame = () =>
  new Promise((resolve) => requestAnimationFrame(resolve));
